module.exports = __webpack_public_path__ + "img/people.e8764432.jpg";